import { faIndianRupee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import Biling from '../whatsapp/small_component/popup/biling'
import Preloader from '../CommerceManager/component/Loader';
import { faCheckCircle, faRocket, faCrown } from '@fortawesome/free-solid-svg-icons';
import './subscription.css';
import Razorpay from '../whatsapp/small_component/biling/razorpay';
import domain from '../reusecomponent/domain';
import { ErrorToastContainer, SuccessToastContainer } from '../whatsapp/function/CustomFunction';
import { useSelector } from 'react-redux';


function Subscription() {
    const [visible, setvisible] = useState(false);
    const [loder, setloder] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState(null);
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [selectedDuration, setSelectedDuration] = useState('monthly');
    const Accesstoken = useSelector((state) => (state.Token.value));

    const [bilininformation, setBilininformation] = useState({
      plan_id: null,
      havegst: '',
      gstnumber: '',
      validated: null,
      store_code: null,
      amount: 0,
      referel_code: '',
      referel_code_validate: null,
    });

    useEffect(() => {
      const fetchSubscriptionData = async () => {
        try {
          setloder(true);
          const access_token = Accesstoken;
          const myHeaders = new Headers();
          myHeaders.append('Authorization', `Bearer ${access_token}`);

          const requestOptions = {
            method: 'GET',
            headers: myHeaders,
          };

          const response = await fetch(`${domain()}/subscription/gmb`, requestOptions);
          const result = await response.json();
          
          if (result.status && result.data) {
            setSubscriptionData(result.data);
            console.log(subscriptionData);
          } else {
            setSubscriptionData([]);
          }
        } catch (error) {
          setSubscriptionData([]);
        } finally {
          setloder(false);
        }
      };

      fetchSubscriptionData();
    }, []);

    // Parse features string to array
    const parseFeatures = (featuresString) => {
      if (!featuresString) return [];
      try {
        const parsed = JSON.parse(featuresString);
        return Array.isArray(parsed) ? parsed : [featuresString];
      } catch (e) {
        // If parsing fails, split by comma or return as single item
        if (typeof featuresString === 'string') {
          return featuresString.includes(',') ? featuresString.split(',').map(f => f.trim()) : [featuresString];
        }
        return [];
      }
    };

    // Get plan icon based on plan name
    const getPlanIcon = () => {
      return faRocket;
    };

    const handlePurchase = async () => {
        setloder(true);
        try {
          const access_token = Accesstoken;
          const myHeaders = new Headers();
          myHeaders.append('Authorization', `Bearer ${access_token}`);
          myHeaders.append('Content-Type', 'application/json');
          let payload = {
           plan_id: bilininformation.plan_id,
          };

          if(bilininformation.havegst === 'Yes' && bilininformation.validated === true){
            payload = {
                ...payload,
              gst_number: bilininformation.gstnumber,
            };
          }

          payload = {
              ...payload,
            product: 'gmb',
            referel_code: bilininformation.referel_code,
            store_code: bilininformation.store_code
          };

          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(payload),
          };
          const res = await fetch(`${domain()}/order/subscription`, requestOptions);
          const result = await res.json();
          if (result.status && result.data) {
            let data = JSON.parse(atob(result.data));
            setvisible(false);
            setBilininformation({
              plan_id: null,
              havegst: '',
              gstnumber: '',
              validated: null,
              store_code: null,
              amount: 0
            });
            setPaymentInfo(data);
          } else {
            ErrorToastContainer(result.message || 'Payment initiation failed');
          }
        } catch (e) {
          ErrorToastContainer('Payment initiation error');
        }finally {
          setloder(false);
        }
    }
    
    const handlePaymentStatus = async () => {
      try {
        setloder(true)
        const access_token = Accesstoken;
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${access_token}`);
        const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
        };
        // Use order_id from paymentInfo
        const orderId = paymentInfo?.order_id;
        const res = await fetch(`${domain()}/order-status/subscription/${btoa(orderId)}`, requestOptions);
        const result = await res.json();
        if (result.status) {
          let finaldata = atob(result.data);
          finaldata = JSON.parse(finaldata);
          if (finaldata.status === '1') {
            SuccessToastContainer(finaldata.message || 'Credits added successfully!');
          } else if (finaldata.status === '0') {
            ErrorToastContainer(finaldata.message || 'Payment failed.');
          } else {
            ErrorToastContainer('Payment pending. Please check later.');
          }
        } else {
          ErrorToastContainer(result.message || 'Payment verification failed.');
        }
      } catch (e) {
        ErrorToastContainer('Internal Server Error');
      }finally {
        setloder(false);
        setPaymentInfo(null);
      }
    };

    const filteredPlans = subscriptionData.filter(plan => {
      if (!plan.duration) return true;
      return plan.duration.toLowerCase() === selectedDuration.toLowerCase();
    });

    const getPlanColor = (planName) => {
      const themeColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--companycolor')?.trim() || '#075E54';
      if (!planName) return themeColor;
      const name = planName.toLowerCase();
      if (name.includes('basic') || name.includes('free')) return themeColor;
      if (name.includes('pro') || name.includes('premium')) return '#222';
      if (name.includes('enterprise') || name.includes('business')) return '#5f6fff';
      return themeColor;
    };

    return (
      <div className="subscription-container px-3">
        {/* Header Section */}
        <div className="subscription-header">
          <h1 className="subscription-title">Get started with Campaigning Tool CRM!</h1>
          <div className="subscription-subtitle">Choose the plan that fits your business. No hidden fees.</div>
        </div>
        
        {/* Duration Toggle Buttons */}
        <div className="duration-toggle-container">
          <div className="duration-toggle">
            <button
              className={`duration-btn ${selectedDuration === 'monthly' ? 'active' : ''}`}
              onClick={() => setSelectedDuration('monthly')}
            >
              Monthly
            </button>
            <button
              className={`duration-btn ${selectedDuration === 'yearly' ? 'active' : ''}`}
              onClick={() => setSelectedDuration('yearly')}
            >
              Yearly
              <span className="save-badge">Save 20%</span>
            </button>
          </div>
        </div>
        
        {visible && (<Biling componentvisible={setvisible} payNow={handlePurchase} bilininformation={bilininformation} setBilininformation1={setBilininformation} setPreloader={setloder} product='gmb'/>)}
        <Razorpay paymentInfo={paymentInfo} handlePaymentStatus={handlePaymentStatus}/>
        {loder &&(
          <Preloader/>
        )}
        
        <div className="subscription-content">
          <div className="subscription-grid">
            {/* Render plans dynamically */}
            {(() => {
              try {
                if (filteredPlans && Array.isArray(filteredPlans) && filteredPlans.length > 0) {
                  return filteredPlans.map((plan, index) => {
                    try {
                      if (!plan || typeof plan !== 'object') {
                        return null;
                      }
                      
                      const planName = plan.name || 'Plan';
                      const planDescription = plan.description || 'No description available';
                      const planAmount = plan.amount || 0;
                      const planFeatures = plan.features || '';
                      const planId = plan.id || `plan-${index}`;
                      
                      return (
                        <div key={planId} className="subscription-card">
                          <div className="plan-header">
                            <div className="plan-icon" style={{ color: getPlanColor(planName) }}>
                              <FontAwesomeIcon icon={getPlanIcon(planName)} />
                            </div>
                            <h5 className="plan-name">{planName}</h5>
                            <div className="plan-description">{planDescription}</div>
                          </div>
                          
                          <div className="plan-price" style={{ color: getPlanColor(planName) }}>
                            <FontAwesomeIcon icon={faIndianRupee} />
                            {planAmount} 
                            {plan.add_gst === 'yes' && <span className="plan-price-gst">+GST</span>}
                          </div>
                          
                          <ul className="feature-list">
                            {parseFeatures(planFeatures).map((feature, featureIndex) => (
                              <li key={featureIndex}>
                                <FontAwesomeIcon 
                                  icon={faCheckCircle} 
                                  style={{color: getPlanColor(planName)}}
                                />
                                {feature}
                              </li>
                            ))}
                          </ul>
                          
                          {1 ? (
                          <button 
                            type="button" 
                            className={`subscription-button ${
                              getPlanColor(planName) === '#5f6fff' ? 'outline-primary' : 
                              getPlanColor(planName) === '#222' ? 'outline-dark' : 'theme'
                            }`}
                            onClick={() => {
                              setBilininformation((prevValues) => ({
                                ...prevValues,
                                plan_id: plan.id,
                                amount: planAmount,
                              }));
                              setvisible(true);
                            }}
                          >
                            Get Started
                          </button>
                          ) : (
                          <button 
                            type="button" 
                            className="subscription-button disabled"
                            disabled
                            title="You don't have permission to purchase subscriptions"
                          >
                            Get Started
                          </button>
                          )}
                        </div>
                      );
                    } catch (planError) {
                      console.error('Error rendering plan:', planError, plan);
                      return null;
                    }
                  });
                } else {
                  // Show loading or empty state
                  return (
                    <div className="d-flex justify-content-center w-100">
                      <div className="empty-state">
                          <div className="d-flex flex-column align-items-center">
                            <div className="empty-state-icon">
                              <FontAwesomeIcon icon={faCrown} />
                            </div>
                            <h5 className="empty-state-title">
                              {loder ? 'Loading Plans...' : 
                              subscriptionData.length > 0 
                                ? `No ${selectedDuration.charAt(0).toUpperCase() + selectedDuration.slice(1)} Plans Available` 
                                : 'No Subscription Plans Available'}
                            </h5>
                            <p className="empty-state-message">
                              {loder ? 'Please wait while we fetch the latest plans' : 
                              subscriptionData.length > 0 
                                ? `Try switching to ${selectedDuration === 'monthly' ? 'yearly' : 'monthly'} plans or check back soon!`
                                : 'Check back later for available subscription options'}
                            </p>
                          </div>
                      </div>
                    </div>
                  );
                }
              } catch (renderError) {
                return (
                  <div className="d-flex justify-content-center w-100">
                    <div className="empty-state">
                      <div className="d-flex flex-column align-items-center">
                        <div className="error-state-icon">
                          <FontAwesomeIcon icon={faCrown} />
                        </div>
                        <h5 className="error-state-title">Error Loading Plans</h5>
                        <p className="empty-state-message">
                          Please refresh the page or try again later
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            })()}
          </div>
        </div>
      </div>
    );
}

export default Subscription
